/** @jsxImportSource react */
import { Field } from 'react-final-form';

export default function GwizzyField(props) {
  return <Field {...props} />;
}
